var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 20.167A9.167 9.167 0 1 1 20.167 11 9.177 9.177 0 0 1 11 20.167m0-16.5A7.333 7.333 0 1 0 18.333 11 7.34 7.34 0 0 0 11 3.667m4.583 8.25h-5.5v-5.5h1.834v3.666h3.666z"
  })));
};
export default SvgClock;